module.exports = __webpack_public_path__ + "img/app-development.690e24ce.jpg";